export default {
  install (Vue) {
    Vue.prototype.$ee = new Vue()
  }
}
